var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title"},[_c('en',{attrs:{"s":_vm.stitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }